module.exports = __webpack_public_path__ + "static/media/supersets_card_bg.39c12e21.jpg";